var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"modal-button"},[_c('button',{staticClass:"btn border border-dark",class:{
        'btn-primary': _vm.buttonStyle == 'primary',
        'btn-light': _vm.buttonStyle == 'light',
        'active': _vm.isActive
    },attrs:{"type":"button","role":"button"},on:{"click":_vm.toggle}},[(_vm.showIcon && _vm.biIconClassName)?[_c('i',{class:_vm.biIconClassName})]:_vm._e(),_vm._v(" "),(_vm.buttonLabel)?[_vm._v("\n      "+_vm._s(_vm.buttonLabel)+"\n    ")]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68063691","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBarModalButton.vue
// module id = null
// module chunks = 